import { notification } from 'antd';

// Cap the number of "not editable" notifications shown simultaneously so that
// repeatedly clicking the read-only fields doesn't flood the screen.
const MAX_VISIBLE = 3;
let openCount = 0;

export const notifyNotEditable = () => {
  if (openCount >= MAX_VISIBLE) {
    return;
  }
  openCount += 1;
  notification.warning({
    message: 'Read-only item',
    description: 'This K2P was created by an admin and cannot be edited.',
    onClose: () => {
      openCount = Math.max(0, openCount - 1);
    }
  });
};
